export const articulos_informatica_02 =
<div>
<p>
    Cuando estamos trabajando frente a un computador, una gran parte de nuestro tiempo se consume en actividades asociadas a la plena interacción con éste,
    esto quiere decir que nuestro tiempo útil y realmente efectivo es muy poco (si pudieramos calcular el porcentaje te llevarías una sorpresa). En este artículo
    te voy a dar unas pautas para que puedas optimizar tu tiempo frente al computador, éstas van desde recomendaciones sencillas hasta prácticas avanzadas
    que generalmente se soportan con el uso de diferentes tipos de herramientas.
</p>
<p className='subTituloSeccion'>
    !Organiza tus archivos!:
</p>
<p>
    ( En construcción... )
</p>
</div>